import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
// Novera Pro fonts, self-hosted (OFL, OP-F-17): the offline shell keeps its
// layout metrics without the network (AUD-UXDS-21). Latin + Latin Extended
// cover French and transliterated names; weights per ux/01 §2.4.
import "@fontsource/public-sans/latin-400.css";
import "@fontsource/public-sans/latin-500.css";
import "@fontsource/public-sans/latin-600.css";
import "@fontsource/public-sans/latin-700.css";
import "@fontsource/public-sans/latin-ext-400.css";
import "@fontsource/public-sans/latin-ext-500.css";
import "@fontsource/public-sans/latin-ext-600.css";
import "@fontsource/public-sans/latin-ext-700.css";
import "@fontsource/ibm-plex-mono/latin-400.css";
import "@fontsource/ibm-plex-mono/latin-500.css";
import "./index.css";
// Print layer (WP-19): document / label previews and the shell safety net when a page prints.
import "./styles/print.css";
import { contexteFenetre } from "./hooks/useFenetreSource.js";

// X XWP-74 — a window opened by « ouvrir dans une nouvelle fenêtre » takes its source jeton (and
// drops the per-tab sessionStorage the browser copied from its opener) before any page reads it.
contexteFenetre();

const rootElement = document.getElementById("root");

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
